<template>
  <c-box display="flex" alignItems="stretch">
    <c-box
      class="row"
      v-chakra="{
        flex: '1 0 auto',
        height: { base: '90vh', lg: '100vh' },
        maxHeight: { base: '90vh', lg: '100vh' },
        width: '100%',
        paddingTop: { base: '5vh', lg: '10vh' },
        paddingBottom: { base: '5vh', lg: '10vh' },
        display: 'flex',
        justifyContent: 'space-around',
      }"
    >
      <c-box
        class="col-md-12 col-lg-7"
        v-chakra="{
          display: { base: 'none', md: 'flex' },
          justifyContent: 'space-around',
          backgroundImage: `url('/img/login/iloq-login.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          flex: '1 0 auto',
          height: '100%',
          borderRadius: 'rounder',
        }"
      ></c-box>
      <c-box class="col-md-12 col-lg-4">
        <c-box
          data-cy="login-form"
          v-chakra="{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
            paddingTop: { base: 'base', sm: '15vh', md: '2xl', xl: '10vh' },
            margin: '0 5% 0 5%',
          }"
        >
          <c-box v-chakra="{ textAlign: 'right' }">
            <LocaleChanger></LocaleChanger>
          </c-box>
          <c-box
            v-chakra="{
              paddingTop: { base: '5vh', lg: '10vh' },
              display: 'flex',
              flexDirection: 'column',
            }"
          >
            <c-box display="flex" alignContent="center">
              <img src="/img/iloq-partner-portal-login-logo.svg" alt="Partner Portal Logo" />
            </c-box>
            <c-box
              data-cy="login-text"
              fontSize="12pt"
              lineHeight="1.5rem"
              color="black"
              paddingTop="xl"
              paddingBottom="xl"
            >
              <c-text marginBottom="xl">
                {{ $t("login.instructionText") }}
              </c-text>
              <c-box>
                <c-button
                  @click="redirectLogin"
                  backgroundColor="brand.beige"
                  color="brand.purple"
                  border-color="brand.beige"
                  cursor="pointer"
                  borderStyle="solid"
                  :hover="{ backgroundColor: 'brand.beigeLight' }"
                  data-cy="login-button"
                >
                  {{ $t("login.button") }}
                </c-button>
              </c-box>
              <c-text as="span" display="block" marginTop="20px">
                <c-link
                  href="#"
                  @click.stop.prevent="showForgotPasswordDialog = true"
                  textDecoration="none"
                  fontWeight="700"
                >
                  {{ $t("login.forgotPassword.linkText") }}
                </c-link>
              </c-text>
            </c-box>
            <dialog-modal :show-dialog="showForgotPasswordDialog" @close="onDialogClose" size="xl">
              <template v-slot:title>
                <c-heading as="h2" v-chakra size="md">
                  {{ $t("login.forgotPassword.dialog.header") }}
                </c-heading>
              </template>
              <template v-slot:content>
                <div
                  v-html="$t('login.forgotPassword.dialog.body')"
                  v-chakra="{
                    p: {
                      mb: 'md',
                      fontSize: 'sm',
                    },
                    h2: {
                      mb: 'sm',
                      fontSize: 'md',
                      fontWeight: 'bold',
                    },
                  }"
                />
                <c-box class="row" marginTop="xl">
                  <c-box class="col-12 col-sm-6" textAlign="center">
                    <c-link
                      href="https://account.live.com/password/reset"
                      target="_blank"
                      is-external
                    >
                      <img
                        src="/img/login/microsoft_logo.svg"
                        alt="Microsoft Logo"
                        v-chakra
                        height="auto"
                        width="auto"
                        maxHeight="24"
                        maxWidth="100%"
                        padding="xl"
                      />
                    </c-link>
                  </c-box>
                  <c-box class="col-12 col-sm-6" textAlign="center">
                    <c-link
                      href="https://accounts.google.com/signin/recovery"
                      target="_blank"
                      is-external
                    >
                      <img
                        src="/img/login/google_logo.svg"
                        alt="Google Logo"
                        v-chakra
                        height="auto"
                        width="auto"
                        maxHeight="24"
                        maxWidth="100%"
                        padding="xl"
                      />
                    </c-link>
                  </c-box>
                </c-box>
              </template>
            </dialog-modal>
          </c-box>
        </c-box>
      </c-box>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import LocaleChanger from "@/components/LocaleChanger.vue";
import Modal from "@/components/Modal.vue";
import { CBox, CButton, CLink, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Login",
  components: {
    LocaleChanger,
    CButton,
    CBox,
    CText,
    CLink,
    "dialog-modal": Modal,
  },
  data() {
    return {
      showForgotPasswordDialog: false,
    };
  },
  methods: {
    redirectLogin() {
      window.location.href = "/user/login";
    },
    onDialogClose() {
      this.showForgotPasswordDialog = false;
    },
  },
});
</script>
